import React from "react"
import {
    View,
    Flex,
    Text,
    Heading,
    Button,
    Divider,
    CheckboxGroup,
    Checkbox,
} from "@adobe/react-spectrum"
import Draw from "@spectrum-icons/workflow/Draw"
import Delete from "@spectrum-icons/workflow/Delete"
import Visibility from "@spectrum-icons/workflow/Visibility"

const QueueCard = ({
    uniqueKey,
    queue,
    onEdit,
    onDelete,
    styles,
    editPermission,
    deletePermission
}) => {
    // console.log("editPermission ",editPermission);
    
    const alerts = queue.alertTypes
    console.log("alerts from queue card", queue)
    // const channel = queue?.channel
    const { abandoned, wait, onQueueUser, voicemail, waitVolume, callbackScheduled, handled } = alerts
    const enabledAlerts = []
    if (abandoned) enabledAlerts.push("abandoned")
    if (wait) enabledAlerts.push("wait")
    if (onQueueUser) enabledAlerts.push("onQueueUser")
    if (voicemail) enabledAlerts.push("voicemail")
    if (waitVolume) enabledAlerts.push("waitVolume")
    if (callbackScheduled) enabledAlerts.push("callbackScheduled")
    if (handled) enabledAlerts.push("handled")

    return (
        <View UNSAFE_className={styles.card} key={uniqueKey}>
            <Flex
                direction="column"
                gap="size-200"
                UNSAFE_style={{ textAlign: "center" }}
            >
                <Heading
                    UNSAFE_style={{ wordBreak: "break-all", fontWeight: 700 }}
                    level={5}
                >
                    {queue.queueName}
                </Heading>
                <Divider size="S" />
            </Flex>
            <View UNSAFE_style={{width: "100%"}}>
                <CheckboxGroup
                    label={<h5>Enabled Alerts</h5>}
                    defaultValue={enabledAlerts}
                    isEmphasized
                    isReadOnly
                    UNSAFE_style={{width: "100%"}}
                >
                   <Flex direction="row" justifyContent="space-between" wrap="wrap" UNSAFE_style={{width: "100%"}}>
                   {abandoned && (
                    <Checkbox
                        value="abandoned"
                        UNSAFE_style={{ width: "50%" }}
                    >
                        Abandoned Contact
                    </Checkbox>
                   )}
                   {waitVolume && (
                    <Checkbox
                        value="waitVolume"
                        UNSAFE_style={{ width: "50%" }}
                    >
                       Contacts Waiting
                    </Checkbox>
                   )}
                   {onQueueUser && (
                    <Checkbox
                        value="onQueueUser"
                        UNSAFE_style={{ width: "50%" }}
                    >
                        Users Available
                    </Checkbox>
                   )}
                   {voicemail && (
                    <Checkbox
                        value="voicemail"
                        UNSAFE_style={{ width: "50%" }}
                    >
                        Voicemail
                    </Checkbox>
                   )}
                   {wait && (
                    <Checkbox
                        value="wait"
                        UNSAFE_style={{ width: "50%" }}
                    >
                        Wait Time
                    </Checkbox>
                   )}
                   {callbackScheduled && (
                    <Checkbox
                        value="callbackScheduled"
                        UNSAFE_style={{ width: "50%" }}
                    >
                        Callback Scheduled
                    </Checkbox>
                   )}
                   {handled && (
                    <Checkbox
                        value="handled"
                        UNSAFE_style={{ width: "50%" }}
                    >
                        Contact Handled
                    </Checkbox>
                   )}
                   </Flex>
                </CheckboxGroup>
            </View>
            <Divider size="S" />
            <Flex
                direction="row"
                justifyContent={"space-between"}
                marginTop={"10px"}
            >
                <Button
                    UNSAFE_className="pointer"
                    UNSAFE_style={{ width: "50px" }}
                    variant="cta"
                    style="outline"
                    onPress={() => onEdit(queue)}
                >
                    {editPermission ? <Draw /> : <Visibility />}
                </Button>

                <Button
                    UNSAFE_className="pointer"
                    UNSAFE_style={{ width: "50px" }}
                    variant="negative"
                    onPress={() => onDelete(queue?.queueId)}
                    isDisabled={!deletePermission}
                >
                    <Delete />
                </Button>
            </Flex>
        </View>
    )
}

export default QueueCard
